export const BG_PRIMARY = 'rgba(196,179,161,0.9)';
export const BG_SECONDARY = '#7d542e';

export const TEXT_PRIMARY = '#58360f';
export const TEXT_SECONDARY = '#f5f3f0';
export const TEXT_ALTERNATIVE = '#58360f';

export const BG_NAVIGATION = 'rgba(245, 243, 240, 0.92)';
export const ICON_NAVIGATION = '#58360f';

export const DEFAULT_BUTTON_PROPS = '';
